/* template */
<template><div><Index :pageConfig="(pageConfig)" :info="(info)" v-if="(show)"/></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m538d8c97"}'>
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m538d8c97"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isFirst&isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!../../../node_modules/@didi/webpack-config-fin/lib/business/webp-loader.js!./index.mpx?ctorType=page&index=0&isFirst&isPage&lang=js&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["m538d8c97"]
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {"navigationBarTitleText":"","backgroundColor":"#ffffff"},
    // @ts-ignore
    {},
    // @ts-ignore
    {'Index':getComponent(require("../../editor/hy/index.mpx?isComponent&outputPath=components%2Findex43b9d13c%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules),
    true
  )
</script>
